import {useRef} from 'react';

export default function useAudio(path: string) {
  const audioRef = useRef(new Audio(path));

  const handlePlay = () => {
    audioRef.current.loop = false;
    audioRef.current.volume = 0.5;
    audioRef.current.play();
  };

  return {handlePlay};
}
